var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "../src/assets/scss/styles.scss";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Loader from "./components/Common/Loader/Loader";
import { initializeMsal } from "./infrastructure/config/msalConfig";
var rootElement = document.getElementById("root");
var renderApp = function () {
    ReactDOM.createRoot(rootElement).render(_jsx(React.StrictMode, { children: _jsx(Suspense, __assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(I18nextProvider, __assign({ i18n: i18n }, { children: _jsx(App, {}) })) })) }));
};
// MSAL se inicializa y resuelve la vuelta del redirect de Entra antes del primer render.
// En modo 'password' no hace nada. initializeMsal nunca rechaza.
initializeMsal().then(renderApp);
